package com.macrofocus.eflux.ui

import com.macrofocus.common.selection.MutableSingleSelection
import emotion.react.css
import js.objects.unsafeJso
import mui.material.*
import mui.material.Size
import mui.material.styles.Theme
import mui.material.styles.useTheme
import org.w3c.dom.DragEvent
import org.w3c.dom.events.MouseEvent
import popper.core.Modifier
import popper.core.Placement
import react.*
import web.cssom.*

external interface TooltipPopperProps : PropsWithChildren {
    var anchorEl: dynamic
    var placement: Placement
    var getScreenX: Double
    var getClientOffsetX: Double?
    var setClientOffsetX: ((Double) -> Unit)?
    var getScreenY: Double
    var getClientOffsetY: Double?
    var setClientOffsetY: ((Double) -> Unit)?
    var pointerEvent: Boolean
    var dnd: Boolean
    var getGlobalDragging: Boolean
    var setGlobalDragging: StateSetter<Boolean>
    var draggingOnMouseMoveSelection: MutableSingleSelection<(event: react.dom.events.MouseEvent<*, *>) -> Unit>
    var draggingOnMouseUpSelection: MutableSingleSelection<(event: react.dom.events.MouseEvent<*, *>) -> Unit>
//    var classes: TooltipStyle
}

val TooltipPopper = FC<TooltipPopperProps> { props ->
//    val classes = props.classes

    val (getLocalDragging, setLocalDragging) = useState { false }
    val (getLocalOffsetX, setLocalOffsetX) = useState(0.0)
    val (getLocalOffsetY, setLocalOffsetY) = useState(0.0)

    val setGlobalDragging = props.setGlobalDragging

    val (getInitialDragX, setInitialDragX) = useState(0.0)
    val (getInitialDragY, setInitialDragY) = useState(0.0)

    val getClientOffsetX = props.getClientOffsetX
    val getClientOffsetY = props.getClientOffsetY
    val setClientOffsetX = props.setClientOffsetX
    val setClientOffsetY = props.setClientOffsetY

    val draggingOnMouseMoveSelection = props.draggingOnMouseMoveSelection
    val draggingOnMouseUpSelection = props.draggingOnMouseUpSelection

    val draggingOnMouseDownFunction: (event: react.dom.events.MouseEvent<*, *>) -> Unit = useCallback(
        setClientOffsetX,
        setClientOffsetY,
        setLocalOffsetX,
        setLocalOffsetY,
        setLocalDragging,
        setGlobalDragging,
        getInitialDragX,
        getInitialDragY,
        getClientOffsetX,
        getClientOffsetY,
        draggingOnMouseMoveSelection,
        draggingOnMouseUpSelection
    ) {
        if (it.asDynamic().nativeEvent is MouseEvent) {
            val e: MouseEvent = it.asDynamic().nativeEvent
            it.preventDefault()
            it.stopPropagation()
            val x = e.pageX
            val y = e.pageY
            val initialDragX = x
            val initialDragY = y
            setInitialDragX(initialDragX)
            setInitialDragY(initialDragY)
            setLocalOffsetX(0.0)
            setLocalOffsetY(0.0)

            val clientOffsetX = getClientOffsetX
            val clientOffsetY = getClientOffsetY

            setLocalDragging(true)
            setGlobalDragging(true)

            val draggingOnMouseUpFunction: (event: react.dom.events.MouseEvent<*, *>) -> Unit =
                { it: react.dom.events.MouseEvent<*, *> ->
                    if (it.asDynamic().nativeEvent is MouseEvent) {
//                                    println("draggingOnMouseUpSelection " + getLocalDragging)
                        val nativeEvent: MouseEvent = it.asDynamic().nativeEvent
                        it.preventDefault()
                        it.stopPropagation()

                        val nx = nativeEvent.pageX
                        val ny = nativeEvent.pageY
                        val diffX = nx - initialDragX
                        val diffY = ny - initialDragY

                        setClientOffsetX?.invoke(clientOffsetX!! + diffX)
                        setClientOffsetY?.invoke(clientOffsetY!! + diffY)
                        setLocalOffsetX(0.0)
                        setLocalOffsetY(0.0)
                        setLocalDragging(false)
                        setGlobalDragging(false)
                    }
                }

            val draggingOnMouseMoveFunction: (event: react.dom.events.MouseEvent<*, *>) -> Unit = {
                if (it.asDynamic().nativeEvent is MouseEvent) {
                    val e: MouseEvent = it.asDynamic().nativeEvent
                    it.preventDefault()
                    it.stopPropagation()

                    val nx = e.pageX
                    val ny = e.pageY
                    val diffX = nx - initialDragX
                    val diffY = ny - initialDragY

//                                    println("draggingOnMouseMoveSelection " + getLocalDragging + ", " + diffX + ", " + diffY)
                    // Force local update
                    setLocalOffsetX(diffX)
                    setLocalOffsetY(diffY)
                }
            }

            draggingOnMouseMoveSelection.selected = draggingOnMouseMoveFunction
            draggingOnMouseUpSelection.selected = draggingOnMouseUpFunction
        }
    }

//    if(getLocalDragging)
//        println("Dragging " + getLocalOffsetX + ", " + getLocalOffsetY + " / " + getClientOffsetX + ", " + getClientOffsetY)

    Popper {
        css {
            pointerEvents = Auto.auto
        }

        if (props.pointerEvent) {
            if (props.dnd && getLocalDragging) {
//                attrs.className = classes.draggingPopper
                css {
                    pointerEvents = Auto.auto
                }
                draggable = true
            } else {
//                attrs.className = classes.popper
                css {
                    pointerEvents = Auto.auto
                }
                draggable = if (props.dnd) true else false
            }
        } else {
//            attrs.className = classes.passivePopper
            css {
                pointerEvents = Auto.auto
            }

            draggable = false
        }

        open = true
        anchorEl = props.anchorEl
        placement = props.placement
        disablePortal = true
        modifiers = arrayOf<Modifier<*>>(
            // ToDo
//            Hide.modifier {
//                enabled = true
//            },
//            Flip.modifier {
//                enabled = false
//            },

//            popper.core.modifiers.Offset.modifier {
////                name = "dragger"
//                enabled = true
////                order = 891
////                requires = arrayOf("popperOffsets")
//                phase = ModifierPhases.main
//                fn = {
//                    val state = it.state.asDynamic()
//                    if (state.styles != null) {
//                        val left = props.getScreenX + getLocalOffsetX
//                        val top = props.getScreenY + getLocalOffsetY
//                        state.styles.left = left
//                        state.styles.top = top
//                    }
//                    state
//                }
//            }

//            Dragger.modifier {
//                name = "dragger"
//                enabled = true
//                order = 891
//                requires = arrayOf("popperOffsets")
//                phase = ModifierPhases.main
//                fn = {
//                    val state = it.state
//                    if (state.styles != null) {
//                        val left = props.getScreenX + getLocalOffsetX
//                        val top = props.getScreenY + getLocalOffsetY
//                        state.styles.left = left
//                        state.styles.top = top
//                    }
//                    state
//                }
//                val fn : (dynamic,dynamic) -> Any = { state,options ->
//                    if (state.styles != null) {
//                        val left = props.getScreenX + getLocalOffsetX
//                        val top = props.getScreenY + getLocalOffsetY
//                        state.styles.left = left
//                        state.styles.top = top
//                    }
//                    state
//                }
//            }
        )

//        modifiers = unsafeJso {
//            asDynamic().`hide` = object {
//                val enabled = true
//            }
//            asDynamic().`flip` = object {
//                val enabled = false
//            }
//            asDynamic().`dragger` = unsafeJso {
//                name = "dragger"
//                enabled = true
//                order = 891
//                requires = arrayOf("popperOffsets")
//                phase = "main"
//                val fn : (dynamic,dynamic) -> Any = { state,options ->
//                    if (state.styles != null) {
//                        val left = props.getScreenX + getLocalOffsetX
//                        val top = props.getScreenY + getLocalOffsetY
//                        state.styles.left = left
//                        state.styles.top = top
//                    }
//                    state
//                }
//            }
//        }
//            modifiers = object {
//                val hide = object {
//                    val enabled = true
//                }
//                val flip = object {
//                    val enabled = false
//                }
////                val offset = object {
////                    val enabled = true
////                    val offset = "0, 16"
////                }
//                val dragger = object {
//                    val name = "dragger"
//                    val enabled = true
//                    val order = 891
//                    val requires = arrayOf("popperOffsets")
//                    val phase = "main"
//                    val fn : (dynamic,dynamic) -> Any = { state,options ->
//                        if (state.styles != null) {
//                            val left = props.getScreenX + getLocalOffsetX
//                            val top = props.getScreenY + getLocalOffsetY
//                            state.styles.left = left
//                            state.styles.top = top
//                        }
//                        state
//                    }
//                }
//            }

        if (setClientOffsetX != null && setClientOffsetY != null) {
            if (props.dnd) {
                onDragStart = {
                    if (it.asDynamic().nativeEvent is DragEvent) {
                        val e: DragEvent = it.asDynamic().nativeEvent
                        val x = e.clientX
                        val y = e.clientY
                        setInitialDragX(x.toDouble())
                        setInitialDragY(y.toDouble())

                        setLocalDragging(true)
                        setGlobalDragging(true)

                        e.dataTransfer?.dropEffect = "move"
                    }
                }
                onDragEnd = {
                    if (it.asDynamic().nativeEvent is DragEvent) {
                        val e: DragEvent = it.asDynamic().nativeEvent
                        if (e.dataTransfer?.dropEffect == "move") {
                            val nx = e.clientX
                            val ny = e.clientY
                            val diffX = nx - getInitialDragX
                            val diffY = ny - getInitialDragY

                            setClientOffsetX(getClientOffsetX!! + diffX)
                            setClientOffsetY(getClientOffsetY!! + diffY)
                        }

                        setLocalDragging(false)
                        setGlobalDragging(false)
                    }
                }
                onDragEnter = {
                    it.preventDefault()
                }
                onDragOver = {
                    it.preventDefault()
                }
            } else {
                if (props.pointerEvent) {
                    onMouseDown = draggingOnMouseDownFunction
                }
            }
        }

        +props.children
    }
}

external interface TooltipProps : PropsWithChildren {
    var onClose: (() -> Unit)?
    var onEnter: (() -> Unit)?
//    var classes: TooltipStyle
}

val Tooltip = FC<TooltipProps> { props ->
//    val classes = props.classes

    val onClose = props.onClose
    val onEnter = props.onEnter

    Card {
        val paperColor = useTheme<Theme>().asDynamic().palette.background.paper
        sx = unsafeJso {
            backgroundColor = Color(
                kotlinx.css.Color((paperColor as String)).withAlpha(0.7).toString()
            )
            padding = 0.px
        }

//            elevation = 9
        if (onClose != null) {
            asDynamic().onMouseDown = {
//                    onClose.invoke()
            }
        }
        if (onEnter != null) {
            asDynamic().onMouseOver = {
                onEnter.invoke()
            }
        }
//        attrs.className = classes.tooltip

        +props.children
    }
}

external interface TooltipHeaderProps : PropsWithChildren {
    var title: String
    var getX: Double?
    var setX: ((Double) -> Unit)?
    var getY: Double?
    var setY: ((Double) -> Unit)?
//    var classes: TooltipStyle
}

val TooltipHeader = FC<TooltipHeaderProps> { props ->
//    val classes = props.classes

    CardHeader {
//        attrs.className = classes.tooltipHeader
        val paperColor = useTheme<Theme>().asDynamic().palette.background.paper
        sx = unsafeJso {
            backgroundColor = Color(
                kotlinx.css.Color((paperColor as String)).withAlpha(0.7).toString()
            )
            padding = 10.px
        }

        title = Typography.create {
            sx = unsafeJso {
                fontSize = 0.9.rem
                lineHeight = 1.1.px
                textAlign = TextAlign.center
            }

            +props.title
        }
    }
}

external interface TooltipContentProps : PropsWithChildren {
//    var classes: TooltipStyle
}

val TooltipContent = FC<TooltipContentProps> { props ->
//    val classes = props.classes

    CardContent {
//        attrs.className = classes.tooltipContent
        sx = unsafeJso {
            paddingTop = 0.px
            paddingBottom = 0.px
            paddingLeft = 10.px
            paddingRight = 10.px
        }

        css {
            lastChild {
                paddingBottom = important(4.px)
            }
        }

        TooltipBody {
//            attrs.classes = classes

            +props.children
        }
    }
}

external interface TooltipBodyProps : PropsWithChildren {
//    var classes: TooltipStyle
}

private val TooltipBody = FC<TooltipBodyProps> { props ->
//    val classes = props.classes

    Table {
//        attrs.className = classes.tooltipBody

        size = Size.small

        TableBody {
            +props.children
        }
    }
}

external interface TooltipItemProps : PropsWithChildren {
//    var classes: TooltipStyle
}

val TooltipItem = FC<TooltipItemProps> { props ->
//    val classes = props.classes

    TableRow {
//        attrs.className = classes.tooltipItem

//        attrs {
//        }

        +props.children
    }
}

external interface TooltipCellProps : PropsWithChildren {
//    var classes: TooltipStyle
}

val TooltipCell = FC<TooltipCellProps> { props ->
//    val classes = props.classes

    TableCell {
//        attrs.className = classes.tooltipCell
        sx = unsafeJso {
            fontSize = 0.75.rem
            padding = 0.px
            paddingRight = 4.px
            borderBottom = None.none
        }

        css {
            lastChild {
                paddingRight = important(0.px)
            }
        }

        +props.children
    }
}

external interface TooltipNumberProps : PropsWithChildren {
//    var classes: TooltipStyle
}

val TooltipNumber = FC<TooltipNumberProps> { props ->
//    val classes = props.classes

    TableCell {
//        attrs.className = classes.tooltipNumber
        sx = unsafeJso {
            fontSize = 0.75.rem
            padding = 0.px
            paddingRight = 4.px
            borderBottom = None.none

        }

        css {
            lastChild {
                paddingRight = important(0.px)
            }
        }

        align = TableCellAlign.right

        +props.children
    }
}
